<template>
    <section class="m-mapview">
        <div id="mapContainer">
            <GMapMap ref="gmap"
                      class="maps-search__map"
                      :center="center"
                      :options="mapOptions"
                      style="width:100%;  height: 100%;"
                      :zoom="6">
                <GMapInfoWindow :options="infoWindowOptions" :position="infoWindowPos" :opened="infoWindowOpen" @closeclick="infoWindowOpen=false">
                    <div class="infoBubble" v-if="infoWindowContent && infoWindowContent.DocType == 'mapMarkerType1'">
                        <h3>{{infoWindowContent.Heading}}</h3>

                        <h4 v-if="infoWindowContent.Content.Area">{{infoWindowContent.Content.Area}}</h4>

                        <p class="overline" v-if="infoWindowContent.Content.MarkerTextArea">
                            {{infoWindowContent.Content.MarkerTextArea}}
                        </p>

                        <div v-if="infoWindowContent.Content.CommunityName">
                            <strong>Community:</strong> {{infoWindowContent.Content.CommunityName}}
                        </div>

                        <div v-if="infoWindowContent.Content.StartDate">
                            <strong>Start date:</strong> {{formatDate(infoWindowContent.Content.StartDate)}}
                        </div>

                        <div v-if="infoWindowContent.Content.Website.Url">
                            <strong>Website:</strong> <a :href="infoWindowContent.Content.Website.Url" target="_blank">View website</a>
                        </div>
                    </div>

                    <div class="infoBubble" v-if="infoWindowContent && infoWindowContent.DocType == 'mapMarkerType2'">
                        <h3 v-if="infoWindowContent.Content.Website">
                            <a :href="infoWindowContent.Content.Website" target="_blank" :title="infoWindowContent.Heading">{{infoWindowContent.Content.Applicant}}</a>
                        </h3>
                        <h3 v-else>{{infoWindowContent.Content.Applicant}}</h3>

                        <strong>Area: </strong> {{infoWindowContent.Content.Area}}<br />
                        <strong>Case title: </strong> {{infoWindowContent.Heading}}<br />
                        <br />
                        <a :href="infoWindowContent.Content.Website" target="_blank">View website</a>

                        <p class="overline">
                            {{infoWindowContent.Content.MarkerTextArea}}
                        </p>

                        <div class="element">
                            <label>Land transfer date: </label>
                            <span>{{infoWindowContent.Content.ApprovalYear}}</span>
                        </div>
                        <div class="element">
                            <label>Asset size (if appr.): </label>
                            <span>{{infoWindowContent.Content.AssetSize}} Ha </span>
                        </div>
                        <div class="element">
                            <label>HIE Contribution: </label>
                            <span>£{{formatMoney(infoWindowContent.Content.TotalCost)}}</span>
                        </div>
                    </div>

                    <div class="infoBubble" v-if="infoWindowContent && infoWindowContent.DocType == 'mapRegion'">
                        <h3>{{infoWindowContent.Heading}}</h3>
                        <p class="overline" v-html="infoWindowContent.Content.Description">
                            
                        </p>
                        <a :href="infoWindowContent.Content.Link.Url" target="_blank">{{infoWindowContent.Heading}}</a>

                    </div>
                </GMapInfoWindow>
                <GMapPolygon @click="clickPolygon(path.content)"
                             :key="index"
                             @mouseout="mouseoutPolygon(index)"
                             @mouseover="mouseoverPolygon(index, path.content)"
                             :options="polygonOptions"
                             :paths="path.paths"
                             ref="polygon"
                             v-for="(path, index) in polygonPaths" />
            </GMapMap>
        </div>
    </section>
</template>

<script>
    import Globals from '@/globals.js'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { searchMixin } from '@/mixins/searchMixin.js'
    import { format } from '@/utils/date.js'
    import { createMarkerClusterer } from '@/utils/mapClusterer.js'
    import { addMapMarkerClickListener, createMapIconMarker, getAdvancedMarkerMapOptions, loadAdvancedMarkerLibraryForMap, removeMarker } from '@/utils/mapMarkers.js'

    function getMarkerLocation(content) {
        if (!content) {
            return null
        }

        const location = content.MarkerLocation || content.PropertyLocation || content.PropertyImportLocation

        if (!location) {
            return null
        }

        const latitude = location.lat || location.latitude || location.Latitude
        const longitude = location.lng || location.longitude || location.Longitude

        if (latitude === null || latitude === undefined || longitude === null || longitude === undefined) {
            return null
        }

        return {
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude)
        }
    }

    export default {
        computed: {
            mapOptions: function () {
                return getAdvancedMarkerMapOptions(this.$store.state.mapOptions)
            },

            markerIcon: function () {
                return this.$store.state.mapOptions.markerIcon
            },

            markers: function () {
                var vm = this

                return vm.$store.state.search.results && vm.$store.state.search.results.map(x => {
                    const location = getMarkerLocation(x.Content)

                    if (!location || !Number.isFinite(location.latitude) || !Number.isFinite(location.longitude)) {
                        return null
                    }

                    return {
                        content: x,
                        position: {
                            lat: location.latitude,
                            lng: location.longitude
                        }
                    }
                }).filter(Boolean)
            },

            polygonPaths: function () {
                var vm = this

                return vm.$store.state.search.results && vm.$store.state.search.results.filter(x => x.Content && x.Content.RegionCoordinates).map(x => {
                    return {
                        content: x,
                        heading: x.Heading,
                        paths: x.Content.RegionCoordinates
                    }
                })
            },

            returnUrl: function () {
                return this.$store.state.returnUrl
            }
        },

        created: function () {
            const vm = this

            vm.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
            vm.$store.dispatch('updateSearchFilter', { key: 'showAllResults', value: true })

            vm.$eventHub.$on('search-filtersChanged', vm.onFiltersChanged)
        },

        data() {
            return {
                bgColors: ['f689b2', 'fcc9bf', 'fed482', 'a09fc8', 'fbb685', 'f7886d', 'a3d7a2', '97bde4'],
                center: { lat: 57.4679769, lng: -4.2918971 },
                currentMarkerIndex: null,
                infoWindowContent: '',
                infoWindowOpen: false,
                infoWindowOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -35
                    }
                },
                infoWindowPos: null,
                itemInfoStatus: 'closed',
                loading: true,
                mapLoaded: false,
                mapMarkers: [],
                mapObject: null,
                markerClusterer: null,
                markerRenderId: 0,
                oms: null,
                polygonOptions: {
                    strokeColor: '#ffffff',
                    strokeOpacity: 0.8,
                    strokeWeight: 1,
                    fillColor: '#2288ca',
                    fillOpacity: 0.35,
                    mouseover: function (e) {
                        console.log(e)
                    }
                },
                propertySummary: null,
                searchApiUrl: '/umbraco/api/MapsSearchApi/Search'
            }
        },

        methods: {
            clearMapMarkers: function () {
                if (this.markerClusterer) {
                    this.markerClusterer.clearMarkers()

                    if (this.markerClusterer.setMap) {
                        this.markerClusterer.setMap(null)
                    }

                    this.markerClusterer = null
                }

                this.mapMarkers.forEach(removeMarker)
                this.mapMarkers = []
            },

            clickMarker: function (position, content, index) {
                var vm = this
                vm.center = position

                vm.infoWindowPos = position
                vm.infoWindowContent = content

                //check if its the same marker that was selected if yes toggle
                if (vm.currentMarkerIndex == index) {
                    vm.infoWindowOpen = !vm.infoWindowOpen
                }
                // if different marker set infowindow to open and reset current marker index
                else {
                    vm.infoWindowOpen = true
                    vm.currentMarkerIndex = index
                }
            },

            clickPolygon: function (content) {
                if (content.Content.Link && content.Content.Link.Url) {
                    window.location.href = content.Content.Link.Url
                }
            },

            formatDate: function (date) {
                return format(new Date(date), Globals.dateFormatUi)
            },

            init: function () {
                this.search(true)
            },

            renderMapMarkers: async function () {
                if (!this.mapObject) {
                    return
                }

                const markerRenderId = this.markerRenderId + 1
                this.markerRenderId = markerRenderId

                this.clearMapMarkers()

                if (!this.markers || this.markers.length === 0) {
                    return
                }

                await loadAdvancedMarkerLibraryForMap(this.mapOptions)

                if (markerRenderId !== this.markerRenderId) {
                    return
                }

                this.mapMarkers = this.markers.map((markerData, index) => {
                    const marker = createMapIconMarker({
                        position: markerData.position,
                        icon: this.markerIcon,
                        mapObject: this.mapObject
                    })

                    addMapMarkerClickListener(marker, () => {
                        this.clickMarker(markerData.position, markerData.content, index)
                    })

                    return marker
                })

                this.markerClusterer = createMarkerClusterer({
                    map: this.mapObject,
                    markers: this.mapMarkers,
                    maxZoom: 18
                })

                this.$nextTick(() => {
                    window.requestAnimationFrame(() => {
                        if (this.markerClusterer && this.markerClusterer.redraw) {
                            this.markerClusterer.redraw()
                        }
                    })
                })
            },

            mouseoutPolygon: function (index) {
                var vm = this
                const polygon = vm.$refs.polygon[index].$polygonObject

                polygon.setOptions(
                    {
                        fillColor: '#2288ca'
                    }
                )
                
                vm.infoWindowOpen = false
            },

            mouseoverPolygon: function (index, content) {
                var vm = this
                const polygon = vm.$refs.polygon[index].$polygonObject

                polygon.setOptions(
                    {
                        fillColor: '#56ad4f'
                    }
                )

                vm.infoWindowPos = vm.polygonCenter(polygon)
                vm.infoWindowContent = content
                vm.infoWindowOpen = true
            },

            onFiltersChanged: function () {
                this.search(true)
            },

            polygonCenter: function (poly) {
                var lowx,
                    highx,
                    lowy,
                    highy,
                    lats = [],
                    lngs = [],
                    paths = poly.getPaths()

                for (let i = 0; i < paths.length; i++) {
                    let vertices = paths.getAt(i)

                    for (let o = 0; o < vertices.length; o++) {
                        lngs.push(vertices.getAt(o).lng())
                        lats.push(vertices.getAt(o).lat())
                    }
                }

                lats.sort()
                lngs.sort()
                lowx = lats[0]
                highx = lats[lats.length - 1]
                lowy = lngs[0]
                highy = lngs[lngs.length - 1]
                const center_x = lowx + ((highx - lowx) / 2)
                const center_y = lowy + ((highy - lowy) / 2)

                return (new google.maps.LatLng(center_x, center_y))
            }
        },

        mounted: function () {
            const vm = this

            vm.$gmapApiPromiseLazy().then(() => {
                vm.$refs.gmap.$mapPromise.then(map => {
                    vm.mapObject = map
                    vm.init()
                    vm.mapLoaded = true
                })
            })
        },

        mixins: [globalMixin, searchMixin],

        unmounted: function () {
            this.markerRenderId += 1
            this.clearMapMarkers()
        },

        watch: {
            markers: function () {
                this.$nextTick(this.renderMapMarkers)
            }
        }
    }
</script>

<style>
    .maps-search__map {
        width: 100%;
        height: 100%;
    }
</style>
